export default {
  condition: {
    id: 'pickers_list_condition',
    defaultMessage: 'Condition',
  },
  goodDeal: { id: 'good_deal', defaultMessage: 'Hot deal' },
  soldOut: {
    id: 'already_sold',
    defaultMessage: 'Sold out',
  },
}
